module.exports = __webpack_public_path__ + "img/page-07.e0a97708.jpg";